import { getToken, onMessage } from 'firebase/messaging';
import { messaging, isSupported } from './firebase';
import API from './api/axios';

const VAPID_KEY = 'BLckZDJ679qQXXXPZpg1c64fq4_e_Sr8m-tiJUqf9FwA4qZLA-7tTi9VKGO1U4iQJqsrtkQ_ybpr1yodkAq907U';

export const requestForToken = async () => {
  try {
    // Don't run for unauthenticated users
    if (!localStorage.getItem('userInfo')) return null;

    const supported = await isSupported();
    if (!supported || !messaging) {
      return null;
    }

    if (!('serviceWorker' in navigator) || !('Notification' in window)) {
      return null;
    }

    // Only request if permission hasn't been decided yet
    if (Notification.permission === 'default') {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return null;
    } else if (Notification.permission === 'denied') {
      return null;
    }

    // Use the existing service worker registration
    const registration = await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    if (token) {
      // Check if we've already saved this token to avoid redundant API calls
      const lastToken = localStorage.getItem('lastFcmToken');
      if (lastToken === token) return token;

      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        try {
          await API.put('/api/users/fcm-token', { token });
          localStorage.setItem('lastFcmToken', token);
        } catch (error) {
          // Silent fail
        }
      }
      
      return token;
    }
  } catch (err) {
    // Error handling for production
  }
};

// Handle foreground messages - subscription style
export const onMessageListener = (callback) => {
  if (!messaging) return () => {};
  
  return onMessage(messaging, (payload) => {
    callback(payload);
  });
};
